import { $can } from '@pendo/permissions';

export function hasAppDetailsViewerAccessForAppId (id) {
    return $can(id).entity('applicationDetails').action('view');
}

export function hasInstallationSettingsViewerAccessForAppId (id) {
    return $can(id).entity('installationSettings').action('view');
}

export function hasRawEventsViewerAccessForAppId (id) {
    return $can(id).entity('rawEvent').action('view');
}

export function hasManagementAccessForAppIds (ids) {
    return ids.some(hasManagementAccessForAppId);
}

export function hasManagementAccessForAppId (id) {
    return (
        hasAppDetailsViewerAccessForAppId(id)
        || hasInstallationSettingsViewerAccessForAppId(id)
        || hasRawEventsViewerAccessForAppId(id)
    );
}
